import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/EmployeeDashboard.css";
const EmployeeDashboard = () => {
  const [interns, setInterns] = useState([]);
  const [showInterns, setShowInterns] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedIntern, setSelectedIntern] = useState(null); // intern being updated
  const [assignmentStatuses, setAssignmentStatuses] = useState({}); // current statuses
  const [updating, setUpdating] = useState(false); // to show saving state
  const [showUpload, setShowUpload] = useState(false);
  const [file, setFile] = useState(null);
  const [assignmentNumber, setAssignmentNumber] = useState("");
  const [selectedInternEmail, setSelectedInternEmail] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [submittedAssignments, setSubmittedAssignments] = useState([]);
  const [showSubmittedAssignments, setShowSubmittedAssignments] = useState(false);
  const [loadingAssignments, setLoadingAssignments] = useState(false);
  const [submittedBatch, setSubmittedBatch] = useState("");
  useEffect(() => {
    const fetchInterns = async () => {
      try {
        const response = await axios.get(
          "https://cveysolutions.in/api/intern/all"
        );
        setInterns(response.data);
      } catch (err) {
        console.error("Error fetching interns:", err);
      }
    };

    fetchInterns();
  }, []);
  // ✅ Add this function here, before return
  const handleUpdateIntern = async (intern) => {
    setSelectedIntern(intern);

    const assignments = {
      assignment1: intern.assignment1 || "Pending",
      assignment2: intern.assignment2 || "Pending",
      assignment3: intern.assignment3 || "Pending",
      assignment4: intern.assignment4 || "Pending",
    };

    setAssignmentStatuses(assignments);
  };


  // Update dropdown values
  const handleStatusChange = (assignment, value) => {
    setAssignmentStatuses((prev) => ({ ...prev, [assignment]: value }));
  };

  // Save assignment statuses
  const handleSaveAssignments = async () => {
    if (!selectedIntern) return;
    setUpdating(true);
    try {
      await axios.post(`https://cveysolutions.in/api/intern/update-assignments`, {
        email: selectedIntern.email,
        assignments: assignmentStatuses
      });
      alert("✅ Assignment statuses updated!");
      setSelectedIntern(null);
    } catch (err) {
      console.error(err);
      alert("❌ Failed to update assignments");
    } finally {
      setUpdating(false);
    }
  };
  // Fetch intern data when button is clicked
  const handleInternData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://cveysolutions.in/api/intern/all"
      );
      setInterns(response.data);
      setShowInterns(true);
    } catch (err) {
      console.error("Error fetching intern data:", err);
      setInterns([]);
      setShowInterns(false);
    } finally {
      setLoading(false);
    }
  };
  // Generate ID and Password for intern
  const handleGenerateCredentials = async () => {
    const email = prompt("Enter the intern's email ID:");
    if (!email) {
      alert("Email is required!");
      return;
    }

    // Auto-detect backend URL (works for both local & live)
    const BASE_URL = window.location.origin.includes("localhost")
      ? "http://localhost:5000"
      : "https://cveysolutions.in";

    try {
      const response = await axios.post(`${BASE_URL}/api/intern/generate-credentials`, { email });
      if (response.data.success) {
        alert(`✅ ID and Password have been generated and sent to ${email}`);
      } else {
        alert("⚠️ Failed to generate credentials. Try again.");
      }
    } catch (error) {
      console.error("Error generating credentials:", error);
      alert("❌ Error: Could not generate credentials. Please check the console for details.");
    }
  };
  const handleUpload = async () => {
    if (!file || !assignmentNumber || !selectedInternEmail) {
      return alert("Please select assignment and file");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("assignment", assignmentNumber);
    formData.append("internEmail", selectedInternEmail);
    const BASE_URL = window.location.origin.includes("localhost")
      ? "http://localhost:5000"
      : "https://cveysolutions.in";

    try {
      await axios.post(
        `${BASE_URL}/api/admin/upload-assignment`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("✅ Assignment uploaded successfully!");
      setShowUpload(false);
      setFile(null);
      setAssignmentNumber("");
    } catch (err) {

      console.error("UPLOAD ERROR:", err);

      console.log(err.response?.data);

      alert(
        err.response?.data?.message ||
        "❌ Upload failed"
      );
    }
  };
  const filteredInterns = selectedBatch
    ? interns.filter(
      (intern) =>
        intern.batch &&
        intern.batch.toLowerCase() === selectedBatch.toLowerCase()
    )
    : interns;
  const filteredSubmittedAssignments = submittedBatch
    ? submittedAssignments.filter(
      (assignment) => assignment.batch === submittedBatch
    )
    : submittedAssignments;
  const handleViewSubmittedAssignments = async () => {
    setLoadingAssignments(true);

    const BASE_URL = window.location.origin.includes("localhost")
      ? "http://localhost:5000"
      : "https://cveysolutions.in";

    try {
      const response = await axios.get(
        `${BASE_URL}/api/admin/submitted-assignments`
      );

      setSubmittedAssignments(response.data);
      setShowSubmittedAssignments(true);
    } catch (err) {
      console.error("Error fetching submitted assignments:", err);
      alert("❌ Failed to fetch submitted assignments");
    } finally {
      setLoadingAssignments(false);
    }
  };
  return (
    <div className="employee-dashboard-container">
      {/* 🏠 Go Home Button */}
      <Link to="/" className="go-home-btn">← Go to Home</Link>

      {/* Top-right buttons */}
      <div className="top-right-buttons">
        <button onClick={handleGenerateCredentials}>Generate ID and Password for Intern</button>
        <button onClick={handleInternData}>Intern Data</button>
        <button
          onClick={async () => {
            const rollNo = prompt("Enter Intern ID (Roll Number):");
            if (!rollNo) return alert("Intern ID is required!");

            const BASE_URL = window.location.origin.includes("localhost")
              ? "http://localhost:5000"
              : "https://cveysolutions.in";

            try {
              const response = await axios.get(
                `${BASE_URL}/api/intern/by-rollno/${rollNo}`
              );

              await handleUpdateIntern(response.data);

            } catch (err) {
              alert("Intern not found");
            }
          }}
        >
          Update Intern Data
        </button>
        <button onClick={() => setShowUpload(true)}>
          Upload Assignments
        </button>
        <button onClick={handleViewSubmittedAssignments}>
          View Submitted Assignments
        </button>
      </div>

      {/* Dashboard Content */}
      <div className="dashboard-content">
        <h1>Welcome to Your Employee Dashboard!</h1>
        <p>You have successfully logged in.</p>
      </div>

      {/* Intern Table */}
      {loading && <p style={{ color: "#fff", marginTop: "20px" }}>Loading...</p>}

      {showInterns && interns.length > 0 && (
        <div className="intern-table-container">
          <h2>Intern Registrations</h2>
          <table className="intern-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>College</th>
                <th>Course</th>
                <th>Year</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Internship Type</th> {/* NEW COLUMN */}
              </tr>
            </thead>
            <tbody>
              {interns.map((intern) => (
                <tr key={intern.id}>
                  <td>{intern.name}</td>
                  <td>{intern.college}</td>
                  <td>{intern.course}</td>
                  <td>{intern.yearOfPassing}</td>
                  <td>{intern.mobile}</td>
                  <td>{intern.email}</td>
                  <td>{intern.internshipType}</td> {/* SHOW NEW FIELD */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showInterns && interns.length === 0 && !loading && (
        <p style={{ color: "#fff", marginTop: "20px" }}>No intern data available.</p>
      )}
      {selectedIntern && (
        <>
          <div className="modal-overlay" onClick={() => setSelectedIntern(null)}></div>
          <div className={`modal show`}>
            <h3>Update Assignments for {selectedIntern.name}</h3>
            <div className="intern-info">
              <p><strong>Intern ID:</strong> {selectedIntern.roll_no}</p>
              <p><strong>Name:</strong> {selectedIntern.name}</p>
              <p><strong>Email:</strong> {selectedIntern.email}</p>
              <p><strong>Internship Type:</strong> {selectedIntern.intern_type}</p>
              <p><strong>Batch:</strong> {selectedIntern.batch}</p>
            </div>
            {Object.keys(assignmentStatuses).length === 0 ? (
              <p>No assignments found for this intern.</p>
            ) : (
              Object.keys(assignmentStatuses).map((key) => (
                <div key={key} style={{ marginBottom: "10px" }}>
                  <label>{key}: </label>
                  <select
                    className={`dropdown ${assignmentStatuses[key].toLowerCase()}`} // add status as class
                    value={assignmentStatuses[key]}
                    onChange={(e) => handleStatusChange(key, e.target.value)}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Completed">Completed</option>
                  </select>

                </div>
              ))
            )}
            <button onClick={handleSaveAssignments} disabled={updating}>
              {updating ? "Saving..." : "Save"}
            </button>
            <button onClick={() => setSelectedIntern(null)}>Cancel</button>
          </div>
        </>
      )}

      {showUpload && (
        <>
          <div className="modal-overlay" onClick={() => setShowUpload(false)}></div>

          <div className="modal show">
            <h3>Upload Assignment</h3>
            <select
              value={assignmentNumber}
              onChange={(e) => setAssignmentNumber(e.target.value)}
            >
              <option value="">Select Assignment</option>
              <option value="assignment1">Assignment 1</option>
              <option value="assignment2">Assignment 2</option>
              <option value="assignment3">Assignment 3</option>
              <option value="assignment4">Assignment 4</option>
            </select>
            {/* Batch Selection */}
            <select
              value={selectedBatch}
              onChange={(e) => setSelectedBatch(e.target.value)}
            >
              <option value="">Select Batch</option>
              <option value="Batch 2">Batch 2</option>
              <option value="Batch 3">Batch 3</option>
            </select>

            {/* Intern Selection */}
            <select
              value={selectedInternEmail}
              onChange={(e) => setSelectedInternEmail(e.target.value)}
            >
              <option value="">Select Intern</option>

              {filteredInterns.map((intern) => (
                <option key={intern.email} value={intern.email}>
                  {intern.name} - {intern.email}
                </option>
              ))}
            </select>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <button onClick={handleUpload}>Upload</button>
            <button onClick={() => setShowUpload(false)}>Cancel</button>
          </div>
        </>
      )}
      {showSubmittedAssignments && (
        <div className="intern-table-container">
          <h2>Submitted Assignments</h2>
          <div style={{ marginBottom: "15px" }}>
            <select
              value={submittedBatch}
              onChange={(e) => setSubmittedBatch(e.target.value)}
            >
              <option value="">All Batches</option>
              <option value="Batch 2">Batch 2</option>
              <option value="Batch 3">Batch 3</option>
            </select>
          </div>
          {loadingAssignments ? (
            <p>Loading...</p>
          ) : filteredSubmittedAssignments.length === 0 ? (
            <p>No submitted assignments found.</p>
          ) : (
            <table className="intern-table">

              <thead>
                <tr>
                  <th>Batch</th>
                  <th>Intern Name</th>
                  <th>Assignment</th>
                  <th>Submitted File</th>
                </tr>
              </thead>

              <tbody>
                {filteredSubmittedAssignments.map((assignment, index) => (
                  <tr key={index}>
                    <td>
                      <span
                        className={
                          assignment.batch === "Batch 2"
                            ? "batch2"
                            : "batch3"
                        }
                      >
                        {assignment.batch}
                      </span>
                    </td>

                    <td>{assignment.name}</td>

                    <td>{assignment.assignment_key}</td>

                    <td>
                      <a
                        href={`https://cveysolutions.in/uploads/internSolutions/${assignment.file_name}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {assignment.file_name}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default EmployeeDashboard;
